import React, {useState} from 'react'
import axios from 'axios';
import {useNavigate} from "react-router-dom";

import {useAuthUser} from 'react-auth-kit'
const Addemployee = () => {
  const auth = useAuthUser();  
  let navigate = useNavigate();  
  const [emp, setEmp] = useState({
    name: '',
    phone:'',
  });
 
 
  
  const onChangeValue = (e) => {
    setEmp({
      ...emp,
      [e.target.name]:e.target.value
    });
  
    
  } 
  
  
  const addemp = async(event) => {
     
     
    try {
      event.preventDefault();
      event.persist();
  
      const username =  auth().username;
      const key = auth().key;
    
    
      var formData = new FormData();
      formData.append("name",emp.name); 
      formData.append("phone",emp.phone); 
      formData.append("username",username); 
      formData.append("key",key); 

      axios.post(`https://diamond.future-swift.com/api/addemployee.php`, formData)
      .then(res => {
        console.log(res.data);
        navigate(`/myemployee`);
       
       })
    } catch (error) { throw error;}    
  
  };
  
  return (
    
    <dev>
      
     
    <form className="insertForm" onSubmit={addemp}>
      <h1> اضافة حساب/موظف جديد </h1>
    
      <br /> <br />
    <label htmlFor="_name">أسم الحساب</label>
    <input
      type="text"
      id="_name"
      name="name"
      onChange={onChangeValue}
      placeholder="Enter name"
      autoComplete="off"
      required
    />

    <br /> <br />
    <label htmlFor="_phone">رقم الهاتف</label>
    <input
      type="phone"
      id="_phone"
      name="phone"
      onChange={onChangeValue}
      placeholder="Enter Phone"
      autoComplete="off"
      required
    />
   
    <br /> <br />
      <input type="submit" value="حفظ" />
    </form>
    </dev>
  )
  }


export default Addemployee;









